// extracted by mini-css-extract-plugin
export default {"cls1":"ProfileFeed-cls1___0ccf8e0f3c2ea74210f","cls2":"ProfileFeed-cls2___8a87585e47475dce83d ProfileFeed-cls1___0ccf8e0f3c2ea74210f"};